import { render, staticRenderFns } from "./Solar.vue?vue&type=template&id=408af81c&scoped=true&"
import script from "./Solar.vue?vue&type=script&lang=ts&"
export * from "./Solar.vue?vue&type=script&lang=ts&"
import style0 from "./Solar.vue?vue&type=style&index=0&id=408af81c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408af81c",
  null
  
)

export default component.exports